import { TabListContainer, TabListContent } from './Tabs.styles';
import { memo, useRef, useEffect } from 'react';

interface props {
  children: JSX.Element[] | JSX.Element;
  scrollRight: boolean;
  colorPanel?: boolean;
}

const TabList: React.FC<props> = ({ children, colorPanel, scrollRight }) => {
  const list = useRef<HTMLDivElement>(null);

  useEffect(() => {
    const x = +scrollRight * 200;
    list.current?.scrollTo(x, 0);
  }, [scrollRight]);

  return (
    <TabListContainer ref={list} $hidden={colorPanel}>
      <TabListContent>{children}</TabListContent>
    </TabListContainer>
  );
};

export default memo(TabList);
